import localFont from 'next/font/local';
import { Lora } from 'lib/fonts/local-font-references';

const lora = Lora({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-lora',
  weight: ['400', '600'],
});

const poppins = localFont({
  src: [
    { path: '../../../public/fonts/poppins-400.woff2', weight: '400' },
    { path: '../../../public/fonts/poppins-600.woff2', weight: '600' },
  ],
  display: 'swap',
  variable: '--font-poppins',
  declarations: [{ prop: 'font-family', value: 'Poppins' }],
});

export const supportedFonts = [lora, poppins];
